import { Image } from "antd";
import React from "react";
/** @jsxImportSource @emotion/react */
import { styled } from "twin.macro";
import { isEmpty } from "../../lib/helpers/helpers";
import EmptyData from "../EmptyData/EmptyData";
import { DetailsHomeWrapper } from "../WeddingDetails/component";

const ImageWrapper = styled(Image)`
	width: 100%;
	height: 100%;
	min-height: 250px;
	max-height: 500px;
`;

const StoryDisplay = ({ story }) => {
	return (
		<DetailsHomeWrapper>
			<div
				tw="bg-white min-w-full flex flex-col whitespace-pre-wrap gap-2 overflow-y-scroll"
				style={{ minHeight: "25vh" }}>
				{isEmpty(story) ? (
					<EmptyData
						description={
							<span tw="text-appPink font-semibold">
								No story content here!
							</span>
						}
					/>
				) : (
					story?.map((content, i) => {
						// console.log(content);
						if (content.type === "image") {
							return (
								<div
									tw="flex flex-row items-center justify-center relative"
									key={i}>
									<ImageWrapper
										src={content.url}
										alt={"image"}
										tw="rounded-2xl shadow-md bg-gray-200"
									/>
								</div>
							);
						}
						return (
							<p tw="text-sm text-left opacity-80" key={i}>
								{content.content}
							</p>
						);
					})
				)}
			</div>
		</DetailsHomeWrapper>
	);
};

export default StoryDisplay;
